import { capitalizeFirstLetter } from "../../utils";

export function getRequiredErrorMessage(fieldname?: string): string {
  if (fieldname) return `${capitalizeFirstLetter(fieldname)} is required`;
  return "This field is required";
}
